import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import CheckoutSettings from "./CheckoutSettings";
import PresentationSettings from "./PresentationSettings";
import FieldGroupOrderHub from "./FieldGroupOrderHub";
import Hub from "./Hub";
import { FORM_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";

const FormBlock = (props) => {
  const name = props.name;

  const { values } = useFormikContext();
  const menuIntent = get(values, STATE_KEYS.EDITOR.MENU_INTENT);
  let content = null;

  const showCheckout = menuIntent === FORM_INTENT.CHECKOUT_SETTINGS;
  const showFields = menuIntent === FORM_INTENT.FIELD_GROUP_ORDER;
  const showPresentation = menuIntent === FORM_INTENT.PRESENTATION_SETTINGS;
  const settingsProps = {
    name
  };

  if (showCheckout) {
    content = <CheckoutSettings {...settingsProps} />;
  } else if (showFields) {
    content = <FieldGroupOrderHub {...props} />;
  } else if (showPresentation) {
    content = <PresentationSettings {...settingsProps} />;
  } else {
    content = <Hub {...props} />;
  }

  return content;
};

FormBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default FormBlock;
